// Desafios "auto" se calculan solos a partir de la racha/sesiones ya
// registradas en plan+completion. Los "manual" son marcas personales (ej:
// maximos de repeticiones) que la app no puede verificar por si sola, asi
// que el usuario las marca a mano.
export const challengeDefinitions = [
  {
    id: 'racha-7',
    title: 'Racha de 7 dias',
    description: 'Completa tu rutina 7 dias seguidos.',
    type: 'auto',
    metric: 'streak',
    target: 7,
  },
  {
    id: 'racha-30',
    title: 'Racha de 30 dias',
    description: 'Completa tu rutina 30 dias seguidos.',
    type: 'auto',
    metric: 'streak',
    target: 30,
  },
  {
    id: 'sesiones-10',
    title: '10 sesiones completadas',
    description: 'Termina 10 entrenamientos completos.',
    type: 'auto',
    metric: 'sessions',
    target: 10,
  },
  {
    id: 'sesiones-30',
    title: '30 sesiones completadas',
    description: 'Termina 30 entrenamientos completos.',
    type: 'auto',
    metric: 'sessions',
    target: 30,
  },
  {
    id: 'flexiones-100',
    title: '100 flexiones',
    description: 'Completa 100 flexiones en una sola sesion (con pausas).',
    type: 'manual',
  },
  {
    id: 'dominadas-10',
    title: '10 dominadas estrictas',
    description: 'Logra 10 dominadas estrictas seguidas, sin impulso.',
    type: 'manual',
  },
  {
    id: 'plancha-3min',
    title: 'Plancha 3 minutos',
    description: 'Mantene una plancha frontal por 3 minutos.',
    type: 'manual',
  },
  {
    id: 'amrap-sin-parar',
    title: 'AMRAP sin pausas',
    description: 'Completa un circuito AMRAP de 20 min sin detenerte.',
    type: 'manual',
  },
]
